export const EMPTY_SUB_MESSAGE = "activation.homepage.widget.competitors_traffic_share.empty.topic.sub_message";

export const GROWING = "activation.homepage.widget.state.growing";
export const DECLINING = "activation.homepage.widget.state.declining";
export const STAGNATING = "activation.homepage.widget.state.stagnating";
